<div class="main-container">
  <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <mat-card appearance="outlined">
      <mat-card-title>Edit Account Information</mat-card-title>
      <mat-card-content>
        <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="serverError">
          Error occurred
        </div>

        <app-mat-text-input [formControl]="getFormControl('firstName')" label="First Name" name="firstName"
                            [submitted]="submitted"></app-mat-text-input>
        <app-mat-text-input [formControl]="getFormControl('lastName')" label="Last Name" name="lastName"
                            [submitted]="submitted"></app-mat-text-input>
        <app-mat-phone-number-input [formControl]="getFormControl('phoneNumber')" label="Phone Number"
                                    name="phoneNumber" [submitted]="submitted"></app-mat-phone-number-input>
        <app-mat-text-input [formControl]="getFormControl('email')" label="Email" name="email"
                            [submitted]="submitted"></app-mat-text-input>
      </mat-card-content>
      <mat-card-actions>
        <button mat-raised-button type="submit" color="primary" matTooltip="Save changes"
                [promiseBtn]="buttonSubmitPromise">Save
        </button>
      </mat-card-actions>
    </mat-card>

    <mat-card appearance="outlined">
      <mat-card-title>User Settings</mat-card-title>
      <mat-card-content>
        <mat-form-field appearance="outline" class="regular-form-field with-icon">
          <mat-label>Color Scheme</mat-label>
          <mat-select [(value)]="colorScheme" (valueChange)="updateColorScheme()">
            <mat-select-trigger fxFlex fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="start center">
              <mat-icon [style.color]="colorScheme === 'main-theme' ? '#4862e5' : '#2e3d83'">circle</mat-icon>
              <span>{{ colorScheme === 'main-theme' ? 'Light' : 'Dark' }}</span>
            </mat-select-trigger>
            <mat-option value="main-theme">
              <mat-icon style="color: #4862e5">circle</mat-icon>
              Light
            </mat-option>
            <mat-option value="main-theme-dark">
              <mat-icon style="color: #2e3d83">circle</mat-icon>
              Dark
            </mat-option>
          </mat-select>
        </mat-form-field>

        <app-mat-checkbox-input [formControl]="getFormControl('useManualReportsFiltering')"
                                label="Use Button to Manual Filtering" name="useManualReportsFiltering"
                                [submitted]="submitted"></app-mat-checkbox-input>

      </mat-card-content>
      <mat-card-actions>
        <button mat-raised-button type="submit" color="primary" matTooltip="Save changes"
                [promiseBtn]="buttonSubmitPromise">Save
        </button>
      </mat-card-actions>
    </mat-card>

    <mat-card appearance="outlined">
      <mat-card-title>Security</mat-card-title>
      <mat-card-content>
        <app-mat-password-input [formControl]="getFormControl('oldPassword')"
                                label="Old Password" name="oldPassword"
                                [submitted]="submitted"></app-mat-password-input>
        <app-mat-password-input [formControl]="getFormControl('newPassword')"
                                label="New Password" name="newPassword"
                                [submitted]="submitted"></app-mat-password-input>
        <app-mat-password-input [formControl]="getFormControl('confirmPassword')"
                                [customErrors]="{mismatchedFields: 'Passwords do not match'}"
                                label="Confirm Password" name="confirmPassword"
                                [submitted]="submitted"></app-mat-password-input>
      </mat-card-content>
      <mat-card-actions>
        <button mat-raised-button type="submit" color="primary" matTooltip="Save changes"
                [promiseBtn]="buttonSubmitPromise">Save
        </button>
      </mat-card-actions>
    </mat-card>

    <mat-card appearance="outlined">
      <mat-card-title>Two Factor Authentication</mat-card-title>
      <mat-card-content>

        <app-mat-checkbox-input formControlName="twoFactorEnabled"
                                label="Enable Two Factor Authentication" name="twoFactorEnabled"
                                (click)="twoFactorStateChanged()"
                                [submitted]="submitted"></app-mat-checkbox-input>
        <p-message severity="info" *ngIf="profileModel.twoFactorActivated">
          <span class="p-message-icon pi pi-info-circle"></span>
          <span class="p-message-detail">
              Two factor authentication is enabled and verified. <br>
              Two factor authentication method is
              <b>{{ profileModel.twoFactorProvider === 'authenticator' ? 'Authenticator App' : profileModel.twoFactorProvider === 'phoneNumber' ? 'SMS Message' : 'E-mail Message' }}</b>
              <b *ngIf="profileModel.twoFactorSource">&nbsp;-&nbsp;{{ profileModel.twoFactorSource | phoneNumber }}</b>
              <br>
              <br>To reset two factor authentication click <button type="button" mat-stroked-button
                                                                   (click)="resetTwoFactor()">reset</button>
            </span>
        </p-message>
      </mat-card-content>
      <mat-card-actions>
        <button mat-raised-button type="submit" color="primary" matTooltip="Save changes"
                [promiseBtn]="buttonSubmitPromise">Save
        </button>
      </mat-card-actions>
    </mat-card>
  </form>
</div>
